import React from 'react';
import Footer from '../layout/Footer';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

export default function BookClosure() {
    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <Card.Title className='mb-0'>Book Closure</Card.Title>
                                            <div>
                                                <Button variant="primary">Book Close</Button>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </>
    )
}
